import { FC, ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoginPage from 'src/pages/Auth/Login/index';
import useRefMounted from 'src/hooks/useRefMounted';

interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props: { children: any }) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const isMountedRef = useRefMounted();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation && isMountedRef()) {
      setRequestedLocation(location.pathname);
    }
    return <LoginPage />;
  }

  if (requestedLocation && location.pathname !== requestedLocation && isMountedRef()) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  
  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node
};

export default Authenticated;
